import React, { useEffect, useState } from 'react'
import { MdRefresh, MdClose } from 'react-icons/md'
import { versionStore } from '@/services/versionStore'
import '@/styles/components/update-toast.css'

/**
 * "A new version is available" — bottom right, offered rather than forced.
 *
 * Deliberately not an automatic reload: someone half-way through changing their
 * order would lose the dialog and whatever they had typed into it. The new
 * build is waiting on the next reload either way, so nothing is lost by asking.
 */
const UpdateAvailableToast: React.FC = () => {
  const [stale, setStale] = useState(versionStore.isStale())

  useEffect(() => versionStore.subscribe(setStale), [])

  // Not in the Dynamics view (DF-345): reloading it would drop the staff
  // sign-in, and staff get the new build the next time they open a customer.
  if (!stale || window.location.pathname.startsWith('/crm/')) return null

  return (
    <div className="update-toast" role="status" aria-live="polite">
      <div className="update-toast-text">
        <span className="update-toast-title">A new version of My Portal is available</span>
        <span className="update-toast-detail">Please refresh the page.</span>
      </div>
      <button
        type="button"
        className="update-toast-reload"
        onClick={() => versionStore.refresh()}
      >
        <MdRefresh aria-hidden="true" />
        Refresh
      </button>
      <button
        type="button"
        className="update-toast-dismiss"
        onClick={() => versionStore.dismiss()}
        aria-label="Dismiss"
      >
        <MdClose aria-hidden="true" />
      </button>
    </div>
  )
}

export default UpdateAvailableToast
